// Evergreen Wireless device catalogue (source: "Evergreen Wireless - Device
// Opportunities_SYNNEX.pdf", pages 2-5).
//
// - `categoryKey`, `badgeKey`, spec `key`s and highlight `qualifier`s are i18n
//   keys under `catalogue.*` in public/locales/{lng}/newdevices.json.
// - Spec values are kept verbatim from the PDF (model/spec values are not translated).
// - Each spec value is an array of lines.

const deviceCatalogue = [
  {
    id: "schok",
    name: "SCHOK",
    type: "phone",
    categoryKey: "flipPhone",
    image: "/images/devices/schok.webp",
    badgeKey: "limitedQuantities",
    highlights: {
      display: [{ value: "3.2” (480x800)" }, { value: "+ 2.0”" }],
      camera: [{ value: "8 MP", qualifier: "rear" }],
      battery: [{ value: "1,650 mAh" }],
      memory: [
        { value: "1 GB", qualifier: "ram" },
        { value: "8 GB", qualifier: "storage" },
      ],
    },
    specs: [
      {
        key: "display",
        value: ["3.2” TFT WVGA (480x800) LCD", "sub display 2.0”"],
      },
      {
        key: "networkBands",
        value: [
          "LTE: B2, B4, B5, B12, B13, B17, B25, B26, B28, B30, B41, B66, B71",
          "VoLTE Supported",
        ],
      },
      { key: "rearCamera", value: ["8 MP"] },
      { key: "processor", value: ["Qualcomm MSM8909 - 1.1 GHz Quad-Core"] },
      { key: "battery", value: ["1,650 mAh"] },
      { key: "ram", value: ["1 GB"] },
      { key: "storage", value: ["8 GB + Card Slot"] },
      { key: "dimensions", value: ["112 x 58 x 19mm"] },
    ],
  },
  {
    id: "pine",
    name: "PINE",
    type: "phone",
    categoryKey: "flipPhone",
    image: "/images/devices/pine.webp",
    highlights: {
      display: [
        { value: "2.8”", qualifier: "inside" },
        { value: "1.8”", qualifier: "outside" },
      ],
      camera: [{ value: "0.3 MP" }],
      battery: [{ value: "1,200 mAh" }],
      memory: [
        { value: "1 GB", qualifier: "ram" },
        { value: "8 GB", qualifier: "storage" },
      ],
    },
    specs: [
      {
        key: "display",
        value: ["2.8\" QVGA (240×320) +", "1.77\" QQVGA (128×160)"],
      },
      {
        key: "networkBands",
        value: ["LTE: B2/B4/B5/B7/B12/B13/B17/66/71", "VoLTE Supported"],
      },
      { key: "rearCamera", value: ["0.3 MP"] },
      { key: "processor", value: ["Qualcomm QM215 - 1.3 GHz Quad-Core"] },
      { key: "battery", value: ["1,200 mAh"] },
      { key: "ram", value: ["1 GB"] },
      { key: "storage", value: ["8 GB + 32 GB Card Slot"] },
      { key: "dimensions", value: ["110 × 56.6 × 19.8 mm, 135g"] },
    ],
  },
  {
    id: "pulse",
    name: "PULSE",
    type: "phone",
    categoryKey: "smartphone",
    image: "/images/devices/pulse.webp",
    highlights: {
      display: [{ value: "6.5” HD+" }, { value: "1600 x 720" }],
      camera: [
        { value: "13 MP", qualifier: "rear" },
        { value: "5 MP", qualifier: "front" },
      ],
      battery: [{ value: "4,000 mAh" }],
      memory: [
        { value: "3 GB", qualifier: "ram" },
        { value: "32 GB", qualifier: "storage" },
      ],
    },
    specs: [
      { key: "displayResolution", value: ["6.5\" HD+", "1600 x 720"] },
      {
        key: "networkBands",
        value: [
          "4G/LTE - B2/4/5/7/12/13/17/25/26/28/41/66/71",
          "3G/UMTS - B1/2/4/5",
          "2G/GSM - 850/900/1800/1900",
        ],
      },
      { key: "rearCamera", value: ["13MP"] },
      { key: "frontCamera", value: ["5MP"] },
      { key: "processor", value: ["Unisoc SC9863, 1.6GHz Octa core"] },
      { key: "battery", value: ["4,000mAh"] },
      { key: "ram", value: ["3GB"] },
      { key: "storage", value: ["32GB"] },
      { key: "sim", value: ["Dual SIM"] },
      { key: "dimensions", value: ["165 x 76.5 x 8.8mm"] },
    ],
  },
  {
    id: "oak-tab",
    name: "OAK Tab",
    type: "tablet",
    categoryKey: "tablet",
    image: "/images/devices/oak-tab.webp",
    highlights: {
      display: [{ value: "10.1” HD+" }],
      camera: [
        { value: "5 MP", qualifier: "rear" },
        { value: "2 MP", qualifier: "front" },
      ],
      battery: [{ value: "5,000 mAh" }],
      memory: [
        { value: "4 GB", qualifier: "ram" },
        { value: "64 GB", qualifier: "storage" },
      ],
    },
    specs: [
      { key: "display", value: ["10.1\"", "1280 x 800 (HD+)"] },
      { key: "networkBands", value: ["LTE: B2/B4/B5/B7/B12/B13/B17/66/71"] },
      { key: "rearCamera", value: ["5 MP"] },
      { key: "frontCamera", value: ["2 MP"] },
      { key: "processor", value: ["MediaTek MT6769 - 2.0Ghz Octa-Core"] },
      { key: "battery", value: ["5,000 mAh"] },
      { key: "ram", value: ["4 GB"] },
      { key: "storage", value: ["64 GB + SD Card Slot"] },
      { key: "dimensions", value: ["241 x 160 x 9.4 mm"] },
    ],
  },
];

// Look up a catalogue device by its display name (case-insensitive).
export const findDeviceByName = (name) => {
  if (!name) return undefined;
  const needle = name.trim().toLowerCase();
  return deviceCatalogue.find((d) => d.name.toLowerCase() === needle);
};

export default deviceCatalogue;
